export default "__VITE_ASSET__RI0Iorv0__"